module.exports = __webpack_public_path__ + "static/launch-user-tests-directly-bcffe4b495e94e256725b026e46b7426.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/launch-user-tests-directly.png
// module id = 2691
// module chunks = 157636680307020